import {Component} from "react";
import Glob from "../../libs/Glob.mjs";
import TextLabel from "../../controls/TextLabel/TextLabel.mjs";
import LanguageSwitcher from "../../controls/LanguageSwitcher/LanguageSwitcher.mjs";
import "./CannotAuth.css";
import {Button} from "reactstrap";
import AppRefreshIcon from "../../media/app-images/AppRefreshIcon.mjs";
import AppWarningIcon from "../../media/app-images/AppWarningIcon.mjs";
import appLib from "../../libs/appLib.mjs";

const prefix = 'CannotAuth';

const LoginErrorMessage = class extends Component {
	render() {
		if ( this.props.error ) {
			return (
				<p>
					<em><TextLabel value={"Error"} /></em>
					<strong><TextLabel value={this.props.error} /></strong>
				</p>
			)
		}
		if ( this.props.lang==='it') return <p>Il server di autenticazione non risponde correttamente.</p>;
		return <p>Authentication server doesn’t seem to respond.</p>;
	}
}

const CannotAuth = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			lang: Glob.getLanguage(),
			error: Glob.getStatus('loginError')
		}
		this.uid = Glob.generateUid(prefix);
	}
	componentDidMount() {
		Glob.register('Prefs', () =>{
			const l = Glob.getLanguage();
			if ( l === this.state.lang ) return;
			this.setState({lang: l});
		}, this.uid);
		if ( this.state.error ) {
			Glob.setStatus('loginError');
			Glob.setStatus('pageTitle', this.state.error);
		} else {
			Glob.setStatus('pageTitle','CannotAuthTitle');
		}
	}
	componentWillUnmount() {
		Glob.deregister(this.uid);
		Glob.setStatus('pageTitle');
	}
	render() {
		return(
			<div className={"app-panel app-panel-small "+prefix} id={this.uid}>
				<h1 className={"title"}>
					<AppWarningIcon />
					<span>
						<TextLabel value={"CannotAuthTitle"} />
					</span>
				</h1>
				<div className={"panel-content"}>
					<div>
						<div>
							<div className={"LoginError"}>
								<LoginErrorMessage
									lang={this.state.lang}
									error={this.state.error}
								/>
							</div>
							<p>
								<Button
									className={"btn-icon"}
									color="primary"
									onClick={ ()=>{ appLib.logout(true) } }
								>
									<b>
										<TextLabel value={"Retry"} />
									</b>
									<i>
										<AppRefreshIcon />
									</i>
								</Button>
							</p>
						</div>
						<LanguageSwitcher />
					</div>
				</div>
			</div>
		)
	}
}

export default CannotAuth;